/**
 * CallOutcome — a call's outcome as table text: "Answered" (green), "No answer" /
 * "Busy" (amber), "Failed" / "Not placed" (red), with the end reason under it when
 * there is one. A call logged before the outcome columns existed shows a muted dash.
 *
 * Labels and tones come from utils/callOutcome.js, the one reading of a call row.
 *
 * @param {{ call: object, showReason?: boolean }} props
 */
import { callOutcomeLabel, callOutcomeTone, callEndReasonLabel } from '../../utils/callOutcome.js';
import './call-outcome.css';

const CallOutcome = ({ call, showReason = true }) => {
    const label = callOutcomeLabel(call);
    if (!label) return <span className="dp-cell-text dp-cell-text--muted" title="Logged before call outcomes were recorded">{'—'}</span>;
    const reason = showReason ? callEndReasonLabel(call) : '';
    return (
        <span className="call-outcome">
            <span className={`call-outcome__label call-outcome__label--${callOutcomeTone(call)}`}>{label}</span>
            {reason ? <span className="call-outcome__reason">{reason}</span> : null}
        </span>
    );
};

export default CallOutcome;
